<template>
  <v-container  class="px-0">
    <v-form ref="agendaFilterForm">
      <v-row  class="px-0">
        <v-col cols="12" sm="6" md="3">
          <label>Prestador</label>
          <v-select
            v-model="formData.prestador_id"
            :items="prestadoresFilter"
            item-value="id"
            item-text="prest_nome"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <label>Operadora</label>
          <v-select
            v-model="formData.operadora_ans_id"
            :items="operadorasFilter"
            item-value="id"
            item-text="oper_nome"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <label>Responsável</label>
          <v-select
            v-model="formData.owner_id"
            :items="responsaveisFilter"
            item-value="Id"
            item-text="UserName"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-btn
          class="mt-8"
          height="30px"
          small
          style="padding: 0 10px"
          depressed
          color="primary"
          @click="getList(formData)"
        >Filtrar</v-btn>
        <v-spacer></v-spacer>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        operadora_ans_id: null,
        prestador_id: null,
        owner_id: null
      },
      operadorasFilter:[],
      prestadoresFilter:[],
      responsaveisFilter:[]
    }
  },
  props: {
    getList: Function,
    operadoras: Array,
    prestadores: Array,
    responsaveis: Array
  },
  watch: {
    prestadores:{
      deep: true,
      handler(val) {
        this.prestadoresFilter = Array.from(val)
        if(this.prestadoresFilter.length==1){
          this.formData.prestador_id = this.prestadoresFilter[0].id
          this.getList(this.formData)
        } else {
          this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
        }
      }
    },
    operadoras:{
      deep: true,
      handler(val){
        this.operadorasFilter = Array.from(val)
        this.operadorasFilter.unshift({id: null, oper_nome: "Selecione"})
      }
    },
    responsaveis: {
      deep: true,
      handler(val){
        this.responsaveisFilter = Array.from(val)
        this.responsaveisFilter.unshift({Id: null, UserName: "Selecione"})
      }
    },
  },
};
</script>
